module.exports = __webpack_public_path__ + "media/components/assets/images/sseobolgga/image4-2e1688e0b620a202cc1f0e43e42ae80b.png";